import * as e from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/FileVideo.es.js";
const o = e.forwardRef((i, r) => /* @__PURE__ */ e.createElement(t, { ref: r, ...i, weights: a }));
o.displayName = "FileVideoIcon";
const s = o;
export {
  s as FileVideo,
  o as FileVideoIcon
};
